<template>
  <div v-on:input="inputRadioValue">
    <template v-if="descFirst">
      <label v-bind:class="['radio-name', sortClass]" v-show="direction === 'asc'">
        <slot />
        <input hidden type="radio" value="" v-model="direction" :name="name">
      </label>
      <label v-bind:class="['radio-name', sortClass]" v-show="direction === ''">
        <slot />
        <input hidden type="radio" value="desc" v-model="direction" :name="name">
      </label>
      <label v-bind:class="['radio-name', sortClass]" v-show="direction === 'desc'">
        <slot />
        <input hidden type="radio" value="asc" v-model="direction" :name="name">
      </label>
    </template>
    <template v-else>
      <label v-bind:class="['radio-name', sortClass]" v-show="direction === 'desc'">
        <slot />
        <input hidden type="radio" value="" v-model="direction" :name="name">
      </label>
      <label v-bind:class="['radio-name', sortClass]" v-show="direction === ''">
        <slot />
        <input hidden type="radio" value="asc" v-model="direction" :name="name">
      </label>
      <label v-bind:class="['radio-name', sortClass]" v-show="direction === 'asc'">
        <slot />
        <input hidden type="radio" value="desc" v-model="direction" :name="name">
      </label>
    </template>
  </div>
</template>

<script>
export default {
  name: 'InputSort',
  data() {
    return {
      direction: this.value,
    };
  },
  methods: {
    inputRadioValue(e) {
      this.$emit('input', e.target.value);
    },
  },
  watch: {
    value() {
      this.direction = this.value;
    },
  },
  props: {
    name: { require: true, type: String, default: () => '' },
    value: { require: true, type: String, default: () => '' },
    sortClass: { type: String, default: () => '' },
    descFirst: Boolean,
  },
};
</script>

<style scoped>
 .radio-name {
   cursor: pointer;
 }
</style>
